{
  "DocumentViewer_AcceptButton": "Akzeptieren",
  "DocumentViewer_CloseButton": "Schließen",
  "NAME": "DocumentViewer"
}